import { useMemo, useState } from "react";
import PageHeader from "@/components/feature/PageHeader";
import FilterSortBar from "@/components/feature/FilterSortBar";
import ContentCard from "@/components/base/ContentCard";
import EmptyState from "@/components/base/EmptyState";
import { useSEO } from "@/hooks/useSEO";
import { productItems, productCategories } from "@/mocks/content";
import { filterItems, sortItems } from "@/utils/content";

const PAGE_SIZE = 6;

export default function Products() {
  useSEO({
    title: "产品资讯 - 白峰美羽",
    description: "白峰美羽经典、星选、轻享与限定系列产品资讯，感受品质与工艺带来的质感生活。",
    keywords: "白峰美羽,产品资讯,产品系列,新品发布,品质生活",
  });

  const [category, setCategory] = useState("全部");
  const [order, setOrder] = useState<"latest" | "oldest" | "title">("latest");
  const [visible, setVisible] = useState(PAGE_SIZE);

  const filtered = useMemo(() => {
    const items = filterItems(productItems, category);
    return sortItems(items, order);
  }, [category, order]);

  const current = filtered.slice(0, visible);
  const hasMore = visible < filtered.length;

  const reset = () => {
    setCategory("全部");
    setOrder("latest");
    setVisible(PAGE_SIZE);
  };

  return (
    <>
      <PageHeader
        eyebrow="PRODUCTS"
        title="产品资讯"
        description="覆盖经典、星选、轻享与限定系列，了解每一款产品背后的材质与工艺故事。"
        crumbs={[{ label: "首页", path: "/" }, { label: "产品资讯" }]}
      />

      <section className="max-w-site mx-auto px-4 md:px-6 py-10 md:py-14">
        <FilterSortBar
          categories={productCategories}
          activeCategory={category}
          onCategoryChange={(c) => {
            setCategory(c);
            setVisible(PAGE_SIZE);
          }}
          sortOrder={order}
          onSortChange={(o) => {
            setOrder(o);
            setVisible(PAGE_SIZE);
          }}
          sortLabelPrefix="发布时间"
        />

        <div className="mt-8">
          {current.length > 0 ? (
            <div data-product-shop className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {current.map((item) => (
                <ContentCard key={item.id} item={item} />
              ))}
            </div>
          ) : (
            <EmptyState
              title="暂无符合条件的产品"
              description="试试切换产品分类，或重置筛选条件查看全部产品。"
              onReset={reset}
            />
          )}
        </div>

        {hasMore && (
          <div className="flex justify-center mt-10">
            <button
              type="button"
              onClick={() => setVisible((v) => v + PAGE_SIZE)}
              className="px-7 py-3 rounded-md border border-primary-300 text-primary-600 text-sm font-medium hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              加载更多
              <i className="ri-arrow-down-line ml-2"></i>
            </button>
          </div>
        )}
      </section>
    </>
  );
}